import { useRef } from "react";
import { cn } from "../../lib/utils";

export function MagicCard({ className, children, allowOverflow = false }) {
  const ref = useRef(null);

  function handleMove(event) {
    if (!ref.current) return;

    const rect = ref.current.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;

    ref.current.style.setProperty("--mouse-x", `${x}px`);
    ref.current.style.setProperty("--mouse-y", `${y}px`);
  }

  return (
    <div
      ref={ref}
      onMouseMove={handleMove}
      style={{ "--mouse-x": "50%", "--mouse-y": "50%" }}
      className={cn(
        "group relative rounded-2xl border border-slate-700/80 bg-slate-900/70 p-4 shadow-[0_16px_48px_rgba(2,6,23,.45)] backdrop-blur-xl",
        allowOverflow ? "overflow-visible" : "overflow-hidden",
        className
      )}
    >
      <div
        aria-hidden
        className="pointer-events-none absolute -inset-px rounded-[inherit] opacity-0 transition duration-300 group-hover:opacity-100"
        style={{
          background:
            "radial-gradient(220px circle at var(--mouse-x) var(--mouse-y), rgba(34,211,238,0.22), transparent 58%)"
        }}
      />
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 rounded-[inherit] p-px opacity-0 transition duration-300 group-hover:opacity-100"
        style={{
          background:
            "radial-gradient(220px circle at var(--mouse-x) var(--mouse-y), rgba(125,211,252,0.9), rgba(34,211,238,0.55) 38%, transparent 68%)",
          WebkitMask:
            "linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)",
          WebkitMaskComposite: "xor",
          maskComposite: "exclude"
        }}
      />
      <div className="relative">{children}</div>
    </div>
  );
}
